export function instrumentGroup(instrument: { kind: string; market?: string | null; quoteCurrency: string }) {
  if (instrument.kind === 'ETF') {
    return ['SET', 'MAI'].includes(instrument.market?.toUpperCase() || '') || instrument.quoteCurrency === 'THB'
      ? 'TH_EQUITY' : 'US_EQUITY';
  }
  return instrument.kind;
}
